import type { ReactElement } from 'react';

import { Box } from '@/components/Box';
import { Col } from '@/components/Col';
import { Grid } from '@/components/Grid';
import { Row } from '@/components/Row';
import { TransactionSummary } from '@/components/TransactionSummary/TransactionSummary';
import { checkIfAllTaxesExcluded } from '@/lib/regions';
import * as PM from '@/messages/payment';

import { useOrderDetailsContext } from '../OrderDetailsContext';

import * as S from '../OrderDetailsView.styles';

export function OrderTransactionSummarySection(): ReactElement | null {
  const {
    coSalesTax,
    formatMessage,
    hasFulfillment,
    isColoradoBilling,
    isDeposit,
    isPayPerLinkTokenLoading,
    order,
    paths,
    payPerLinkToken,
    preOrderData,
    push,
    salesTax,
  } = useOrderDetailsContext();
  if (hasFulfillment) return null;

  const showPayBalanceButton = Boolean(
    payPerLinkToken || isPayPerLinkTokenLoading,
  );

  return (
    <Box my={2}>
      <Grid>
        <Row>
          <Col md={8}>{null}</Col>
          <Col md={4} xs={12}>
            <TransactionSummary
              channel={order?.channel?.slug}
              coSalesTax={coSalesTax}
              fragment={order}
              isColoradoBilling={isColoradoBilling}
              isDeposit={isDeposit}
              preOrderData={preOrderData}
              salesTax={salesTax}
              showButton={false}
              showPadding={false}
              showPaymentMethodsSection={false}
              showTax={!checkIfAllTaxesExcluded(order?.channel?.slug)}
              voucherType={order?.voucher?.discountValueType}
            />
            {showPayBalanceButton ? (
              <S.BalanceButton
                disabled={Boolean(isPayPerLinkTokenLoading)}
                isProcessing={Boolean(isPayPerLinkTokenLoading)}
                onClick={() => {
                  if (payPerLinkToken) {
                    push(
                      paths.store.order.payment.url({
                        token: payPerLinkToken,
                      }),
                    );
                  }
                }}
              >
                {formatMessage(PM.paymentMessages.payTheBalance)}
              </S.BalanceButton>
            ) : null}
          </Col>
        </Row>
      </Grid>
    </Box>
  );
}
